module.exports = __webpack_public_path__ + "static/hvik_tommi_2-ad886b584b1e3d5d744ab0d1418f864e.jpg";